import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Image from "@vorne/gatsby-theme-marketing/components/image/image";
import Link from "@vorne/gatsby-theme-marketing/components/link/link";

const NavBarTitle = () => {
  const { imageData } = useStaticQuery(graphql`
    query {
      imageData: file(relativePath: { eq: "oee_logo.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, height: 42)
        }
      }
    }
  `);
  return (
    <Link url="/">
      <Image src={imageData} alt="Logo" />
    </Link>
  );
};

export default NavBarTitle;
